const iconicNames = [
  "Terminator",
  "Neo",
  "JohnWick",
  "Gladiator",
  "Maverick",
  "Rambo",
  "Skywalker",
  "Vader",
  "Yoda",
  "Thanos",
  "Joker",
  "HarleyQ",
  "Deadpool",
  "Venom",
  "Loki",
  "Magneto",
  "Bane",
  "Riddler",
  "TwoFace",
  "Sauron",
  "GodOfWar",
  "Kratos",
  "Zeus",
  "Odin",
  "Thor",
  "Hades",
  "Poseidon",
  "Ares",
  "Athena",
  "MasterChief",
  "SamFisher",
  "LaraCroft",
  "Geralt",
  "CJCompton",
  "NikoBellic",
  "Ezio",
  "ArthurMorgan",
  "SolidSnake",
  "Frodo",
  "Aragorn",
  "HanSolo",
  "DarthMaul",
  "RickD",
  "MortyC",
  "Spock",
  "Kirk",
  "DoctorWho",
  "Mando",
  "Goku",
  "Vegeta",
  "Naruto",
  "Sasuke",
  "Luffy",
  "Itachi",
  "LightYagami",
  "Eren",
  "Levi",
  "AllMight",
  "SherlockH",
  "WalterWhite",
  "TonySoprano",
  "TylerDurden",
  "HannibalL",
  "DexterM",
  "FrankCastle",
  "WadeWilson",
  "Predator",
  "Xenomorph",
  "Chucky",
  "Jigsaw",
  "Freddy",
  "Jason",
  "Pennywise",
  "Ghostface",
  "Michael",
  "HAL9000",
  "Optimus",
  "Bumblebee",
  "WallE",
  "RoboCop",
  "T800",
  "Ultron",
  "Jarvis",
  "Glados",
  "Skynet",
  "Gandalf",
  "Dumbledore",
  "Voldemort",
  "Merlin",
  "WitcherG",
  "JonSnow",
  "DaenerysT",
  "TyrionL",
  "Khaleesi",
];

const iconicNumbers = [99, 21, 13, 7, 42, 88, 666, 404, 9000, 800, 300];

export function generateAnonymousName(): string {
  const name = iconicNames[Math.floor(Math.random() * iconicNames.length)];
  const number =
    Math.random() < 0.55
      ? iconicNumbers[Math.floor(Math.random() * iconicNumbers.length)]
      : Math.floor(Math.random() * 900) + 10;
  return `${name}${number}`;
}
